import { render } from "./InvoicePdfA4.vue?vue&type=template&id=05aabd69&scoped=true&ts=true"
import script from "./InvoicePdfA4.vue?vue&type=script&lang=ts"
export * from "./InvoicePdfA4.vue?vue&type=script&lang=ts"

import "./InvoicePdfA4.vue?vue&type=style&index=0&id=05aabd69&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05aabd69"]])

export default __exports__